import { useCurrentModule } from '@app/state';
import { APP_MODULE, APP_MODULE_FEATURE_FLAGS, BUID } from '@mgCommon/constants';
import type { AppModule, UserInfo } from '@mgCommon/types';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

type SelectAppModuleProps = {
  currentModule: AppModule | undefined;
  userInfo: UserInfo;
};

export default function SelectAppModule(props: Readonly<SelectAppModuleProps>) {
  const { currentModule, userInfo } = props;

  const setCurrentModule = useCurrentModule(state => state.setCurrentModule);

  const enabledModulesPerUser: Set<AppModule> = new Set([
    'SMS' as AppModule,
    ...(userInfo === BUID.VLT_PROD ? [] : ['VIBER' as AppModule]),
    ...(userInfo === BUID.UAT || userInfo === BUID.ONLINE_PROD
      ? Object.keys(APP_MODULE).map(key => key as AppModule)
      : []),
  ]);

  const isAppModuleEnabled = (module: AppModule) => {
    const mappedModule = APP_MODULE_FEATURE_FLAGS[module];
    return !!window.MESSAGE_GATEWAY_CONFIG?.enabledAppModules[mappedModule] && enabledModulesPerUser.has(module);
  };

  const handleModuleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const module = e.target.value as AppModule;
    setCurrentModule(module);
  };

  return (
    <Row>
      <Col md={3}>
        <Form.Label htmlFor="messageTypeSelection" aria-label="Message Type Selection">
          <h3>Message Type Selection</h3>
        </Form.Label>
        <Form.Select
          data-testid="message-type-selection"
          id="messageTypeSelection"
          value={currentModule}
          onChange={handleModuleChange}
        >
          <option value="">Select...</option>
          {Object.keys(APP_MODULE).map(module =>
            isAppModuleEnabled(module as AppModule) ? (
              <option key={module} value={module as AppModule}>
                {APP_MODULE[module as AppModule]}
              </option>
            ) : null
          )}
        </Form.Select>
      </Col>
    </Row>
  );
}
